/* =========================================================
   MOVIRA — comportamento da landing page dentro do Shopify
   Sem dependências. As traduções vêm resolvidas do servidor;
   aqui só ficam as poucas cadeias de runtime, em data-*.
   ========================================================= */
(function () {
  'use strict';

  var root = document.querySelector('.movira');
  if (!root) return; // inerte se alguma vez for carregado noutro template

  var CONFIG = { COUNTDOWN_HOURS: 24 };

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  // Raiz de rotas ciente do idioma. Vem do content_for_header.
  // Em /pt/products/x isto é '/pt/', e é o que mantém o checkout no idioma certo.
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* =======================================================
     1. Galeria do produto
     As miniaturas são renderizadas pelo Liquid, com os
     tamanhos certos do CDN. Aqui só se liga o comportamento.
     ======================================================= */
  var gImages = $$('.gallery__img');
  var gThumbs = $$('.gallery__thumb');
  var gIndexEl = $('#galleryIndex');
  var gIndex = 0;

  function showImage(i) {
    if (!gImages.length) return;
    gIndex = (i + gImages.length) % gImages.length;
    gImages.forEach(function (img, k) { img.classList.toggle('is-active', k === gIndex); });
    gThumbs.forEach(function (b, k) {
      b.classList.toggle('is-active', k === gIndex);
      b.setAttribute('aria-selected', String(k === gIndex));
    });
    if (gIndexEl) gIndexEl.textContent = String(gIndex + 1);
  }

  if (gImages.length) {
    gThumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { showImage(i); });
    });

    $$('[data-gallery]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showImage(gIndex + (btn.dataset.gallery === 'next' ? 1 : -1));
      });
    });

    var stage = $('#galleryViewport');
    if (stage) {
      var startX = null;
      stage.addEventListener('pointerdown', function (e) { startX = e.clientX; });
      stage.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 40) showImage(gIndex + (dx < 0 ? 1 : -1));
        startX = null;
      });
      stage.addEventListener('pointercancel', function () { startX = null; });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showImage(gIndex + 1);
        if (e.key === 'ArrowLeft') showImage(gIndex - 1);
      });
      stage.tabIndex = 0;
    }
  }

  /* =======================================================
     2. Carrossel de avaliações
     ======================================================= */
  var reviews = $$('.review');
  var rDots = $$('.reviews__dot');
  var rIndex = 0;
  var rTimer = null;

  if (reviews.length) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var showReview = function (i) {
      rIndex = (i + reviews.length) % reviews.length;
      reviews.forEach(function (r, k) { r.classList.toggle('is-active', k === rIndex); });
      rDots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === rIndex);
        d.setAttribute('aria-selected', String(k === rIndex));
      });
    };

    var restartAuto = function () {
      if (reduceMotion) return;
      clearInterval(rTimer);
      rTimer = setInterval(function () { showReview(rIndex + 1); }, 7000);
    };

    rDots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showReview(i); restartAuto(); });
    });

    $$('[data-review]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showReview(rIndex + (btn.dataset.review === 'next' ? 1 : -1));
        restartAuto();
      });
    });

    restartAuto();

    var carousel = $('.reviews__carousel');
    if (carousel) {
      carousel.addEventListener('mouseenter', function () { clearInterval(rTimer); });
      carousel.addEventListener('mouseleave', restartAuto);
      carousel.addEventListener('focusin', function () { clearInterval(rTimer); });
    }
  }

  /* =======================================================
     3. Estatísticas animadas
     ======================================================= */
  var statsBlock = $('#statsBlock');
  if (statsBlock && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        $$('.stat', statsBlock).forEach(function (stat) {
          var target = parseInt(stat.dataset.value, 10) || 0;
          var bar = $('.stat__bar span', stat);
          if (bar) bar.style.width = target + '%';

          var numEl = $('.stat__num', stat);
          if (!numEl) return;
          var started = performance.now();
          var duration = 1100;
          (function tick(now) {
            var p = Math.min((now - started) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            numEl.textContent = Math.round(target * eased) + '%';
            if (p < 1) requestAnimationFrame(tick);
          })(started);
        });
        io.disconnect();
      });
    }, { threshold: 0.35 });
    io.observe(statsBlock);
  }

  /* =======================================================
     4. Contador da promoção
     ======================================================= */
  var countdownEl = $('#countdown');
  var deadline = null;

  function renderCountdown() {
    if (!countdownEl || !deadline) return;
    var left = Math.floor((deadline - Date.now()) / 1000);
    if (left <= 0) {
      countdownEl.textContent = countdownEl.dataset.expired || '';
      return;
    }
    var h = String(Math.floor(left / 3600)).padStart(2, '0');
    var m = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
    var s = String(left % 60).padStart(2, '0');
    countdownEl.textContent = h + ':' + m + ':' + s;
  }

  if (countdownEl) {
    var KEY = 'movira:deadline';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) { /* modo privado */ }
    deadline = stored ? parseInt(stored, 10) : NaN;
    if (!deadline || isNaN(deadline) || deadline < Date.now()) {
      deadline = Date.now() + CONFIG.COUNTDOWN_HOURS * 3600 * 1000;
      try { localStorage.setItem(KEY, String(deadline)); } catch (e) { /* modo privado */ }
    }
    renderCountdown();
    setInterval(renderCountdown, 1000);
  }

  /* =======================================================
     5. Seletor de cor
     Os preços já vêm formatados do Liquid em data-*, para
     não haver lógica de moeda no browser.
     ======================================================= */
  var form = $('#movira-buy');
  var variantInput = $('#movira-variant-id');
  var qtyInput = $('#movira-qty');
  var addBtn = $('#movira-add');
  var errEl = $('.buy__err');

  var priceNow = $$('[data-price-now]');
  var priceWas = $$('[data-price-was]');
  var priceSave = $$('[data-price-save]');
  var colourName = $$('[data-selected-colour]');

  function applyVariant(radio, isBoot) {
    if (!radio || !variantInput) return;
    variantInput.value = radio.value;

    if (radio.dataset.title) {
      colourName.forEach(function (el) { el.textContent = radio.dataset.title; });
    }
    if (radio.dataset.price) {
      priceNow.forEach(function (el) { el.textContent = radio.dataset.price; });
    }

    var compare = radio.dataset.compare || '';
    priceWas.forEach(function (el) {
      el.textContent = compare;
      el.hidden = !compare;
    });
    priceSave.forEach(function (el) {
      var save = radio.dataset.save || '';
      el.textContent = save;
      el.hidden = !save;
    });

    var available = radio.dataset.available !== 'false';
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available
        ? (addBtn.dataset.labelIdle || addBtn.textContent)
        : (addBtn.dataset.labelSoldOut || addBtn.textContent);
    }

    // No arranque a página já vem servida com a variante certa:
    // não se mexe na galeria nem no URL, para não estragar
    // parâmetros de campanha nem o primeiro fotograma.
    if (isBoot) return;

    var pos = parseInt(radio.dataset.mediaPosition, 10);
    if (!isNaN(pos)) showImage(pos - 1);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState({}, '', url);
    } catch (e) { /* URL antigo, sem problema */ }
  }

  $$('input[name="movira-colour"]').forEach(function (radio) {
    radio.addEventListener('change', function () { applyVariant(radio, false); });
  });

  /* =======================================================
     6. Seletor de quantidade
     ======================================================= */
  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var step = parseInt(btn.dataset.qty, 10) || 0;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 10;
      var next = (parseInt(qtyInput.value, 10) || min) + step;
      qtyInput.value = String(Math.min(max, Math.max(min, next)));
    });
  });

  /* =======================================================
     7. Comprar
     Sem JS o formulário faz POST nativo para /cart/add com
     return_to=/checkout. Com JS, limpamos o carrinho para não
     acumular entre visitas e seguimos para o checkout do idioma.
     ======================================================= */
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || errEl.dataset.generic || '';
    errEl.hidden = false;
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // deixa o POST nativo tratar disto
      e.preventDefault();

      if (errEl) errEl.hidden = true;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.labelBusy || addBtn.textContent;
      }

      var payload = {
        items: [{
          id: Number(variantInput && variantInput.value),
          quantity: Number(qtyInput && qtyInput.value) || 1
        }]
      };

      // O carrinho é partilhado com o resto da loja: limpar evita
      // que um duplo clique ou uma revisita envie o dobro.
      fetch(ROOT + 'cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              throw new Error(body.description || res.statusText);
            });
          }
          window.location.href = ROOT + 'checkout';
        })
        .catch(function (ex) {
          showError(ex && ex.message);
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.dataset.labelIdle || addBtn.textContent;
          }
        });
    });
  }

  /* =======================================================
     8. Barra CTA fixa (mobile)
     ======================================================= */
  var sticky = $('#stickyCta');
  var heroEl = $('.hero');
  var offerEl = $('#encomendar');

  if (sticky && heroEl && 'IntersectionObserver' in window) {
    var pastHero = false;
    var atOffer = false;
    var sync = function () { sticky.classList.toggle('is-visible', pastHero && !atOffer); };

    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(heroEl);

    if (offerEl) {
      new IntersectionObserver(function (entries) {
        atOffer = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(offerEl);
    }
  }

  // O botão da barra fixa submete o formulário de compra em vez de saltar.
  $$('[data-buy-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!form) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  });

  /* =======================================================
     9. Arranque
     ======================================================= */
  var checked = $('input[name="movira-colour"]:checked');
  if (checked) applyVariant(checked, true);
})();
